"use client";

import { useState } from "react";
import { useChat } from "@/components/chat/ChatProvider";
import type { ChatResult } from "@/lib/chat/provider";

export function ChatTestPanel() {
  const chat = useChat();
  const [lastResult, setLastResult] = useState<ChatResult | null>(null);

  const run = async (operation: () => Promise<ChatResult>) => {
    const result = await operation();
    setLastResult(result);
  };

  return (
    <aside className="fixed left-4 top-4 z-[99999] max-w-sm rounded bg-white p-4 text-black shadow-xl">
      <p>Provider: {chat.provider ?? "disabled"}</p>
      <pre className="my-2 max-w-xs overflow-auto text-xs">
        {JSON.stringify(chat.capabilities, null, 2)}
      </pre>

      <div className="flex flex-wrap gap-2">
        <button onClick={() => void run(() => chat.initialize())}>
          Initialize
        </button>
        <button
          onClick={() =>
            void run(() =>
              chat.identifyUser({
                id: "qa-chat-test-user",
                email: "qa-chat@example.invalid",
                name: "QA Chat Test User",
              }),
            )
          }
        >
          Identify Test User
        </button>
        <button onClick={() => void run(() => chat.show())}>Show</button>
        <button onClick={() => void run(() => chat.hide())}>Hide</button>
        <button onClick={() => void run(() => chat.open())}>Open</button>
        <button onClick={() => void run(() => chat.close())}>Close</button>
        <button
          onClick={() =>
            void run(() =>
              chat.trackEvent("qa_chat_event", {
                source: "local_test_panel",
                test: true,
              }),
            )
          }
        >
          Track Event
        </button>
        <button onClick={() => void run(() => chat.logout())}>Logout</button>
      </div>

      <pre className="mt-3 max-w-xs overflow-auto text-xs">
        {JSON.stringify(lastResult, null, 2)}
      </pre>
    </aside>
  );
}
